// extracted by css-extract-rspack-plugin
export default {"vacancyNameWrapper":"vacancy-name-wrapper--PSD41i3dJDUNb5Tr","customColorMagritteLink":"custom-color-magritte-link--vpnos5EPubw4tVcY"};